// Demo data for fast path testing
// All data is coherent and realistic for a business proposal

export const getDemoPayload = () => {
  return {
    clientInformation: {
      companyName: 'Nordic Retail Group',
      industry: 'Retail',
      contactPerson: 'Sarah Nielsen'
    },
    documentContext: {
      purpose: 'Present a strategic partnership to modernize Nordic Retail Group\'s digital infrastructure and enhance customer experience across all touchpoints',
      background: 'Nordic Retail Group operates 150+ stores across Scandinavia with 3,500 employees. Currently facing challenges with legacy systems, fragmented customer data, and outdated in-store technology'
    },
    projectScope: {
      objectives: 'Implement unified commerce platform, modernize POS systems, integrate customer data across channels, improve supply chain visibility, and enable personalized marketing at scale',
      deliverables: ['Supply Chain Audit', 'Process Optimization', 'Training Program', 'Technical Support'],
      timeline: '18-month phased rollout starting Q2 2026'
    },
    thematicSections: {
      sections: ['Market Analysis', 'Competitive Landscape', 'Financial Projections', 'Implementation Plan']
    },
    teamDetails: {
      teamLead: 'Marcus Anderson',
      teamSize: '12 full-time specialists'
    }
  };
};
